/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Pathfinder API
 * API for all Pathfinder applications.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Group,
  GroupRequest,
  GroupsListParams,
  PaginatedGroupList,
  PatchedGroupRequest
} from '../types';

import { apiV2 } from '../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * A view that can cache the queryset. Only to be used with DRF ViewSets
 *
 * * Make sure to call super().perform_destroy(instance) when overriding perform_destroy
 * * A cache hit skips the handler, so object-level permissions (those checked in
 *   `get_object`) never run on a hit. Views that use them must not cache `retrieve`.
 */
export const groupsList = (
    params?: GroupsListParams,
 options?: SecondParameter<typeof apiV2<PaginatedGroupList>>,) => {
      return apiV2<PaginatedGroupList>(
      {url: `/groups/`, method: 'GET',
        params
    },
      options);
    }
  /**
 * A view that can cache the queryset. Only to be used with DRF ViewSets
 *
 * * Make sure to call super().perform_destroy(instance) when overriding perform_destroy
 * * A cache hit skips the handler, so object-level permissions (those checked in
 *   `get_object`) never run on a hit. Views that use them must not cache `retrieve`.
 */
export const groupsCreate = (
    groupRequest: GroupRequest,
 options?: SecondParameter<typeof apiV2<Group>>,) => {
      return apiV2<Group>(
      {url: `/groups/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: groupRequest
    },
      options);
    }
  /**
 * A view that can cache the queryset. Only to be used with DRF ViewSets
 *
 * * Make sure to call super().perform_destroy(instance) when overriding perform_destroy
 * * A cache hit skips the handler, so object-level permissions (those checked in
 *   `get_object`) never run on a hit. Views that use them must not cache `retrieve`.
 */
export const groupsRetrieve = (
    id: string,
 options?: SecondParameter<typeof apiV2<Group>>,) => {
      return apiV2<Group>(
      {url: `/groups/${id}/`, method: 'GET'
    },
      options);
    }
  /**
 * A view that can cache the queryset. Only to be used with DRF ViewSets
 *
 * * Make sure to call super().perform_destroy(instance) when overriding perform_destroy
 * * A cache hit skips the handler, so object-level permissions (those checked in
 *   `get_object`) never run on a hit. Views that use them must not cache `retrieve`.
 */
export const groupsUpdate = (
    id: string,
    groupRequest: GroupRequest,
 options?: SecondParameter<typeof apiV2<Group>>,) => {
      return apiV2<Group>(
      {url: `/groups/${id}/`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: groupRequest
    },
      options);
    }
  /**
 * A view that can cache the queryset. Only to be used with DRF ViewSets
 *
 * * Make sure to call super().perform_destroy(instance) when overriding perform_destroy
 * * A cache hit skips the handler, so object-level permissions (those checked in
 *   `get_object`) never run on a hit. Views that use them must not cache `retrieve`.
 */
export const groupsPartialUpdate = (
    id: string,
    patchedGroupRequest?: PatchedGroupRequest,
 options?: SecondParameter<typeof apiV2<Group>>,) => {
      return apiV2<Group>(
      {url: `/groups/${id}/`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedGroupRequest
    },
      options);
    }
  export type GroupsListResult = NonNullable<Awaited<ReturnType<typeof groupsList>>>
export type GroupsCreateResult = NonNullable<Awaited<ReturnType<typeof groupsCreate>>>
export type GroupsRetrieveResult = NonNullable<Awaited<ReturnType<typeof groupsRetrieve>>>
export type GroupsUpdateResult = NonNullable<Awaited<ReturnType<typeof groupsUpdate>>>
export type GroupsPartialUpdateResult = NonNullable<Awaited<ReturnType<typeof groupsPartialUpdate>>>
